import { BaseServices, EHttpMethod } from 'services/base'
import { urls } from 'services/base/url'

import { TRequestSendKidsPayload } from './types'

const request = (payload: TRequestSendKidsPayload) =>
  BaseServices.request({
    pathname: urls.PUT_KIDS,
    method: EHttpMethod.PUT,
    host: process.env.REACT_APP_API_HOST_CONTA_DIGITAL,
    data: { ...payload.data },
    headers: { 'x-id-ficha-cadastral': payload.header.hsfc },
  })

export const putInteresseKids = async (payload: TRequestSendKidsPayload) => {
  try {
    const response = await request(payload)

    payload.success && payload.success(response.status)
  } catch (error) {
    payload.error && payload.error(error)
  } finally {
    payload.finally && payload.finally()
  }
}
